module.exports = __webpack_public_path__ + "img/zebediah-montoya.aa94bb57.png";